import { get as _get, isFunction as _isFunction, forEach as _forEach } from 'lodash';

import { InvalidInstanceException } from './Exceptions';

class AnalyticsManager {
  constructor() {
    this.analyticsInstances = [];
  }

  addAnalyticsInstance = (instance = {}) => {
    if (
      !_get(instance, 'trackView') ||
      !_isFunction(instance.trackView) ||
      !_get(instance, 'trackEvent') ||
      !_isFunction(instance.trackEvent)
    ) {
      throw new InvalidInstanceException(
        'Instance must contain two function, "trackEvent" and "trackView"',
      );
    }

    if (!this.analyticsInstances.some(o => o instanceof instance.constructor)) {
      this.analyticsInstances.push(instance);
    }
  };

  getComponentName = (fullName = '') =>
    fullName.replace('@vfgroup-oneplatform/', '').replace(/-/g, '').trim();

  getComponentVersion = (componentVersion = '') => componentVersion;

  getComponentOwner = () => 'OnePlatform';

  trackEvent = (eventName, data = {}) => {
    _forEach(this.analyticsInstances, instance => {
      instance.trackEvent(eventName, data);
    });
  };

  trackView = (screenName, data = {}) => {
    _forEach(this.analyticsInstances, instance => {
      instance.trackView(screenName, data);
    });
  };
}

export default AnalyticsManager;
